import { type AppLocale } from 'app-shared/types';

import { LOCALE_STORAGE_KEY } from '@/localization/constants/LocaleStorageKey';
import { activateLocale } from '@/localization/utils/activateLocale';

// Saved first, so the choice survives a reload even if the catalog download
// is slow.
export const switchLocale = async (locale: AppLocale) => {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  await activateLocale(locale);
};
